import { PuzzleIcon } from './Page408.style';
import { PuzzleSvg } from './PuzzleSvg';

export const Icon = () => (
  <PuzzleIcon size="100%" title="connect-ring">
    {PuzzleSvg}
  </PuzzleIcon>
);
